import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
import { ImageRadioButton, ImageRadioButtonSize } from '@as/cotopaxi';
import { isNullOrUndefined } from '@as-react/common-utils';
import { Box, Stack, TextAlpha } from '@yonderland/andes-react';
import { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { I18N_NAMESPACES } from '../../../constants/i18nConstants';
import { generateSwatchFromProductColorVariation, getDiscountIconContent, getExtendedRangeIcon, } from '../../../util/SwatchUtil';
const PRODUCT_TILE_SWATCH_DIMENSION = 24;
const ColorSwatches = ({ productCode, colors, selectedColorId, productCdnDomains, setProductColor, swatchInformation, isShopLanding, }) => {
    const { t } = useTranslation(I18N_NAMESPACES.product);
    const [description, setDescription] = useState();
    const [previousProductCode, setPreviousProductCode] = useState();
    const [previousSelectedColorId, setPreviousSelectedColorId] = useState();
    const [swatches, setSwatches] = useState();
    useEffect(() => {
        const selectedColorVariation = colors.find((colorVariation) => colorVariation.colorId === selectedColorId);
        if (productCode !== previousProductCode || !(swatches === null || swatches === void 0 ? void 0 : swatches.length)) {
            setDescription(selectedColorVariation.translations.description);
            setPreviousProductCode(productCode);
            setPreviousSelectedColorId(selectedColorId);
            setSwatches(colors.map((productColor) => generateSwatchFromProductColorVariation(productColor, selectedColorId, productCode, productCdnDomains)));
        }
        else if (selectedColorId !== previousSelectedColorId) {
            setDescription(selectedColorVariation.translations.description);
            setPreviousSelectedColorId(selectedColorId);
            setSwatches(swatches.map((swatch) => {
                if (!swatch.selected && swatch.colourId === selectedColorId) {
                    return Object.assign(Object.assign({}, swatch), { selected: true });
                }
                else if (swatch.selected && swatch.colourId !== selectedColorId) {
                    return Object.assign(Object.assign({}, swatch), { selected: false });
                }
                else {
                    return swatch;
                }
            }));
        }
        else if (swatches && swatches.length) {
            const newSwatchesState = swatches.map((swatch) => {
                const updatedColor = colors.find((newColor) => newColor.colorId === swatch.colourId);
                if (!isNullOrUndefined(updatedColor)) {
                    return Object.assign(Object.assign({}, swatch), { hasDiscount: updatedColor.hasDiscount });
                }
                return swatch;
            });
            JSON.stringify(newSwatchesState) !== JSON.stringify(swatches) && setSwatches(newSwatchesState);
        }
    }, [swatches, selectedColorId]);
    const setCurrentProductColor = (colourId) => {
        if (colourId !== selectedColorId) {
            setProductColor(colourId);
        }
    };
    return (_jsx(Box, { paddingBlockEnd: "4", children: _jsxs(Stack, { direction: "col", gap: "2", children: [_jsxs(Box, { children: [_jsxs(TextAlpha, { as: "span", strong: true, children: [t('product:pdp.color'), ":", ' '] }), _jsx(TextAlpha, { as: "span", testId: "color_name", children: description })] }), swatches && swatches.length > 1 && (_jsx(Box, { paddingBlockEnd: "2", children: _jsx(Stack, { align: "center", gap: "1", testId: "color_swatches", children: swatches.map((colour, index) => (_jsx(ImageRadioButton, { id: `${productCode}-${colour.colourId}__${index}`, name: `color_swatch_${productCode}`, value: colour.colourId.toString(), checked: colour.colourId === selectedColorId, imageUrl: colour.swatch, imageLazyLoad: true, imageWidth: PRODUCT_TILE_SWATCH_DIMENSION, imageHeight: PRODUCT_TILE_SWATCH_DIMENSION, textImage: getDiscountIconContent(colour, swatchInformation), textOverlay: true, size: ImageRadioButtonSize.LARGE, title: colour.color, onChange: () => setCurrentProductColor(colour.colourId), icon: getExtendedRangeIcon(isShopLanding, colour.extendedRange) }, `${productCode}-${colour.colourId}__${index}`))) }) }))] }) }));
};
export default ColorSwatches;
